import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import auth from "../utils/auth";
import Orders from "../components/Orders";
import Head from "../components/Head";
import "../styles/ControlPanelPage.css";
import { scrollToTop } from '../hooks/useScrollToTop';

const ControlPanelPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("orders");

  if (!auth.isAuthenticated()) {
    auth.logout();
    navigate("/logga-in");
    scrollToTop();
    return;
  }

  if (auth.getUserRole() !== "admin") {
    navigate("/");
    scrollToTop();
    return;
  }

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    scrollToTop();
  };

  return (
    <div className="controlpanel-container">
      <Head title="EssayWriter | Kontrollpanel" />
      <h1 className="controlpanel-title">Administratörspanel</h1>

      <div className="controlpanel-tabs">
        <button
          className={`controlpanel-tab ${activeTab === "orders" ? "controlpanel-tab-active" : ""}`}
          onClick={() => handleTabChange("orders")}
        >
          Orderhantering
        </button>
        <button
          className={`controlpanel-tab ${activeTab === "products" ? "controlpanel-tab-active" : ""}`}
          onClick={() => handleTabChange("products")}
        >
          Produkthantering
        </button>
        <button
          className={`controlpanel-tab ${activeTab === "users" ? "controlpanel-tab-active" : ""}`}
          onClick={() => handleTabChange("users")}
        >
          Användarhantering
        </button>
        <button
          className={`controlpanel-tab ${activeTab === "stats" ? "controlpanel-tab-active" : ""}`}
          onClick={() => handleTabChange("stats")}
        >
          Statistik
        </button>
      </div>

      <div className="controlpanel-content">
        {activeTab === "orders" && <Orders />}
        {activeTab === "products" && <div className="controlpanel-placeholder">Produkthantering kommer snart</div>}
        {activeTab === "users" && <div className="controlpanel-placeholder">Användarhantering kommer snart</div>}
        {activeTab === "stats" && <div className="controlpanel-placeholder">Statistikvisning kommer snart</div>}
      </div>
    </div>
  );
};

export default ControlPanelPage;